import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { RootState } from "../../../../../app/store";
import { NameIdOption } from "../../../../../common/types/commonTypes";
import {
  fetchRecruitmentAreas,
  selectRecruitmentAreaOptions,
} from "../../../../../features/settings/recruitment/recruitmentsSlice";

const useRecruitmentAreasAutocomplete = () => {
  const dispatch = useAppDispatch();
  const recruitmentAreaOptions = useAppSelector(selectRecruitmentAreaOptions);
  const { status } = useAppSelector(
    (state: RootState) => state.recruitments.recruitmentAreas,
  );

  useEffect(() => {
    // Fetch if not already fetched or failed
    if (status === "idle" || status === "failed") {
      dispatch(fetchRecruitmentAreas({}));
    }
  }, [dispatch, status]);

  const recruitmentAreasOptions: NameIdOption[] = recruitmentAreaOptions.map(
    (option) => ({
      id: option.id,
      name: option.name,
    }),
  );

  return {
    recruitmentAreaOptions: recruitmentAreasOptions,
    isLoading: status === "pending",
  };
};

export default useRecruitmentAreasAutocomplete;
